export const openShortfall = (shipment) => {
  const row = shipment?.hub_shortfall;
  if (!row || row.status !== 'open') return null;
  return row;
};

export const HubShortfallNote = ({ shipment }) => {
  const row = openShortfall(shipment);
  if (!row) return null;
  const place = row.hub_name || 'hub';
  const title = row.source === 'crossing'
    ? `Missing at ${place} crossing`
    : `Missing at ${place}`;
  return (
    <p className="text-[11px] text-red-700 mt-1 leading-snug">
      {title}. {row.note}
      {row.marked_by_name ? ` · ${row.marked_by_name}` : ''}
      {' Receive when the parcel arrives.'}
    </p>
  );
};
